import { TPaymentProductType } from './types';

const STORAGE_KEY = 'finpayme_pending_invoice';

export interface IFinpaymePendingInvoice {
  invoice_id: string;
  product_type: TPaymentProductType;
  balance_before?: number;
  expires_at_before?: string;
  consumables?: number;
}

export const setFinpaymePendingInvoice = (invoice: IFinpaymePendingInvoice) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(invoice));
  } catch (error) {
    console.error(error);
  }
};

export const getFinpaymePendingInvoice = (): IFinpaymePendingInvoice | undefined => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return undefined;
    return JSON.parse(raw) as IFinpaymePendingInvoice;
  } catch (error) {
    return undefined;
  }
};

export const clearFinpaymePendingInvoice = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error(error);
  }
};
